var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import { ProfileTeam } from 'app/components/player/PlayerHero/components/ProfileTeam';
import styled from 'styled-components';
import { PlayerName } from 'app/components/player/PlayerHero/components/PlayerName';
import { Avatar } from 'app/components/player/PlayerHero/components/Avatar';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import FollowButton from 'app/components/follow/FollowButton';
import DataInfoPopper from 'app/components/profile/DataInfoPopper';
import { getAge, numberWithThousandSeparator } from 'app/helpers/helpers';
import { useClickTracking } from 'app/hooks/useClickTracking';
import { formatBirthDate } from 'app/helpers/dateHelpers';
import { convertToRoman } from 'app/helpers/convertToRoman';
const Details = styled.div.withConfig({
  componentId: "sc-5t0q5r-0"
})(["display:flex;flex:1;flex-direction:column;overflow:hidden;"]);
const Wrapper = styled.div.withConfig({
  componentId: "sc-5t0q5r-1"
})(["display:flex;.currentRole{display:block;height:1rem;}& div{overflow:hidden;}"]);
const Card = styled.div.withConfig({
  componentId: "sc-5t0q5r-2"
})(["display:flex;flex-direction:column;background:", ";padding:1rem;margin:auto;margin-top:", ";max-width:", "px;", ""], COLORS.white, SIZES['56'], props => props.theme.desktopContentWidth, props => props.theme.desktopLayout(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: ", ";\n   "])), SIZES['72']));
const StyledPlayerHero = styled.div.withConfig({
  componentId: "sc-5t0q5r-3"
})(["display:flex;background:", ";gap:1rem;"], COLORS.white);
const Extras = styled.div.withConfig({
  componentId: "sc-5t0q5r-4"
})(["padding-top:1rem;display:flex;flex-direction:column;height:5rem;.caption{display:flex;justify-content:space-between;padding-bottom:0.25rem;}", ""], props => props.theme.desktopLayout(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 3.625rem;\n  "]))));
const ExtrasContent = styled(Typography).withConfig({
  componentId: "sc-5t0q5r-5"
})(["line-height:1.5;.separator{font-size:1rem;padding:0 0.125rem;}"]);
const SCFollowButton = styled(FollowButton).withConfig({
  componentId: "sc-5t0q5r-6"
})(["&&&{margin:1rem 0;}"]);
const getExtras = profile => {
  var _profile$details, _profile$details2, _profile$details3, _profile$details4, _profile$details5, _profile$details6;
  const attributes = [{
    value: profile === null || profile === void 0 || (_profile$details = profile.details) === null || _profile$details === void 0 ? void 0 : _profile$details.nickname,
    format: value => "\"".concat(value, "\"")
  }, {
    value: profile === null || profile === void 0 ? void 0 : profile.birthday,
    format: value => "\uD83C\uDF82 ".concat(formatBirthDate(value), " (").concat(getAge(value, true), ")")
  }, {
    value: profile === null || profile === void 0 || (_profile$details2 = profile.details) === null || _profile$details2 === void 0 ? void 0 : _profile$details2.height,
    format: value => "".concat(value, " cm")
  }, {
    value: profile !== null && profile !== void 0 && (_profile$details3 = profile.details) !== null && _profile$details3 !== void 0 && _profile$details3.strongFoot && (profile === null || profile === void 0 || (_profile$details4 = profile.details) === null || _profile$details4 === void 0 ? void 0 : _profile$details4.strongFoot) !== 'unknown' ? profile.details.strongFoot : undefined,
    format: value => "starker Fu\xDF: ".concat(value)
  }, {
    value: (profile === null || profile === void 0 || (_profile$details5 = profile.details) === null || _profile$details5 === void 0 ? void 0 : _profile$details5.nationalities.length) > 0 ? profile === null || profile === void 0 || (_profile$details6 = profile.details) === null || _profile$details6 === void 0 ? void 0 : _profile$details6.nationalities : undefined,
    format: value => value.map(nation => nation.icon).join(' ')
  }];
  const extras = attributes.filter(attr => attr.value).map(attr => attr.format(attr.value));
  return extras.map((extra, index) => /*#__PURE__*/React.createElement(React.Fragment, null, extra, index < extras.length - 1 && /*#__PURE__*/React.createElement("span", {
    className: 'separator'
  }, " | ")));
};
const getCurrentTeam = currentTeam => {
  if (currentTeam) {
    var _currentTeam$competit;
    const level = currentTeam.level > 1 ? convertToRoman(currentTeam.level) : '';
    return {
      name: (currentTeam === null || currentTeam === void 0 || (_currentTeam$competit = currentTeam.competition) === null || _currentTeam$competit === void 0 ? void 0 : _currentTeam$competit.slug) === 'uebergangsliga' ? currentTeam.name.middle + ' ' + (currentTeam === null || currentTeam === void 0 ? void 0 : currentTeam.ageGroup.name) : "".concat(currentTeam.name.middle, " ").concat(level),
      url: "/team/".concat(currentTeam.slug),
      image: currentTeam.image
    };
  }
  return null;
};
export const PlayerHero = _ref => {
  var _profile$currentRole, _profile$currentRole2;
  let {
    profile
  } = _ref;
  const {
    clicks
  } = useClickTracking('player', profile);
  const currentTeam = getCurrentTeam(profile === null || profile === void 0 || (_profile$currentRole = profile.currentRole) === null || _profile$currentRole === void 0 ? void 0 : _profile$currentRole.team);
  const currentRole = (profile === null || profile === void 0 || (_profile$currentRole2 = profile.currentRole) === null || _profile$currentRole2 === void 0 ? void 0 : _profile$currentRole2.position) || (profile === null || profile === void 0 ? void 0 : profile.position);
  const extras = getExtras(profile);
  return /*#__PURE__*/React.createElement(Card, {
    "data-sentry-element": "Card",
    "data-sentry-component": "PlayerHero",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, /*#__PURE__*/React.createElement(StyledPlayerHero, {
    "data-sentry-element": "StyledPlayerHero",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, /*#__PURE__*/React.createElement(Avatar, {
    image: profile.image,
    jerseyNumber: profile.jerseyNumber,
    "data-sentry-element": "Avatar",
    "data-sentry-source-file": "PlayerHero.tsx"
  }), /*#__PURE__*/React.createElement(Details, {
    "data-sentry-element": "Details",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    className: "currentRole",
    variant: 'caption1',
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, currentRole), /*#__PURE__*/React.createElement(PlayerName, {
    firstName: profile.firstName,
    lastName: profile.lastName,
    "data-sentry-element": "PlayerName",
    "data-sentry-source-file": "PlayerHero.tsx"
  })), /*#__PURE__*/React.createElement(DataInfoPopper, {
    sx: {
      marginLeft: 'auto',
      alignSelf: 'self-start',
      top: '0.25rem'
    },
    "data-sentry-element": "DataInfoPopper",
    "data-sentry-source-file": "PlayerHero.tsx"
  })), /*#__PURE__*/React.createElement(ProfileTeam, {
    currentTeam: currentTeam,
    "data-sentry-element": "ProfileTeam",
    "data-sentry-source-file": "PlayerHero.tsx"
  }), /*#__PURE__*/React.createElement(SCFollowButton, {
    adjustStyles: false,
    isDesktop: true,
    "data-sentry-element": "SCFollowButton",
    "data-sentry-source-file": "PlayerHero.tsx"
  }))), /*#__PURE__*/React.createElement(Extras, {
    "data-sentry-element": "Extras",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'caption'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: 'caption1',
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, extras ? 'Persönliches' : ''), /*#__PURE__*/React.createElement(Typography, {
    variant: 'caption1',
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, clicks ? "Aufrufe: ".concat(numberWithThousandSeparator(clicks)) : '')), /*#__PURE__*/React.createElement(ExtrasContent, {
    variant: 'body1',
    "data-sentry-element": "ExtrasContent",
    "data-sentry-source-file": "PlayerHero.tsx"
  }, extras)));
};